import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import useWindowWidth from "../hooks/useWindowWidth";
import Tooltip from "./Tooltip";

type ResponsiveGroupedItemsCarouselProps = {
    items: JSX.Element[];
    prevTooltipLabel: string;
    nextTooltipLabel: string;
};

const ResponsiveGroupedItemsCarousel = ({
    items,
    prevTooltipLabel,
    nextTooltipLabel,
}: ResponsiveGroupedItemsCarouselProps) => {
    const width = useWindowWidth(100);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [itemsPerGroup, setItemsPerGroup] = useState(1);

    const maxIndex = Math.ceil(items.length / itemsPerGroup) - 1;

    const handlePrev = () =>
        setCurrentIndex((prev) => (prev - 1 === 0 ? 0 : prev - 1));

    const handleNext = () => {
        setCurrentIndex((prev) => (prev + 1 > maxIndex ? maxIndex : prev + 1));
    };

    useEffect(() => {
        setCurrentIndex(0);
        if (width < 768) {
            setItemsPerGroup(1); // 1 filter per group on mobile
        } else if (width < 992) {
            setItemsPerGroup(2); // 2 filters per group on tablet
        } else if (width < 1200) {
            setItemsPerGroup(3); // 3 filters per group on medium viewport
        } else {
            setItemsPerGroup(items.length); // show all on larger viewport
        }
    }, [width, items.length]);

    let itemsToDisplay = items.slice(
        currentIndex * itemsPerGroup,
        currentIndex * itemsPerGroup + itemsPerGroup
    );

    if (itemsPerGroup > items.length) {
        itemsToDisplay = items;
    }

    return (
        <>
            {itemsToDisplay}
            {itemsPerGroup < items.length && (
                <>
                    <Tooltip text={prevTooltipLabel}>
                        <button
                            className="disabled:opacity-40 mt-1"
                            disabled={currentIndex === 0}
                            onClick={handlePrev}
                        >
                            <CaretLeft />
                        </button>
                    </Tooltip>
                    <Tooltip text={nextTooltipLabel}>
                        <button
                            className="disabled:opacity-40 mt-1"
                            disabled={currentIndex >= maxIndex}
                            onClick={handleNext}
                        >
                            <CaretRight />
                        </button>
                    </Tooltip>
                </>
            )}
        </>
    );
};

export default ResponsiveGroupedItemsCarousel;
